import { Action, createReducer, on } from '@ngrx/store';
import { Ar2UserActions } from './ar2-user-actions.service';

export const STORE_FEATURE_KEY_AR2USER = 'ar2User';

export class TemplatesAndNotificationOffsetsState {
    loadingIndicator: boolean;
    templates: Array<any>;
    notificationOffsets: Array<any>;
}

export const initializeTemplatesAndNotificationOffsetsState: TemplatesAndNotificationOffsetsState = {
    templates: [],
    notificationOffsets: [],
    loadingIndicator: false
};

const reducer = createReducer(
    initializeTemplatesAndNotificationOffsetsState,
  on(Ar2UserActions.getTemplatesAndNotificationOffsets, (state, paryload ) =>
    ({ ...state,
      loadingIndicator: true,
    })),
    on(Ar2UserActions.getTemplatesAndNotificationOffsetsSuccess, (state, { payload }) =>
        ({ ...state,
           templates: payload.templates,
           loadingIndicator: false,
           notificationOffsets: payload.notificationoffsets
        })),
    on(Ar2UserActions.getTemplatesAndNotificationOffsetsFail, (state, payload ) =>
      ({ ...state,
        loadingIndicator: false
      }))
    );

// TODO: Check if we should name it as TemplatesAndNotificationOffsetsReducer
// tslint:disable-next-line:typedef only-arrow-functions
export function Ar2UserReducer(state: TemplatesAndNotificationOffsetsState | undefined, action: Action) {
    return reducer(state, action);
}
